export const getPaymentSuccessful = (payment: GQL.IPayment | undefined) => {
  return (
    payment &&
    (['pending', 'pre-approved', 'approved'] as any).includes(payment.status)
  );
};


// WEBPACK FOOTER //
// ./src/helpers/payment/getPaymentSuccessful.ts